import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AliveScope } from "react-activation";
import { formatDateTime, formatDate } from "@/utils/util";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<AliveScope><App /></AliveScope>);

window.formatDateTime = formatDateTime;
window.formatDate = formatDate;

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
